@use '@lib/assets/styles/main' as *;

.filterWrap {
  padding-bottom: 10px;
}

.filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filterRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.blueIcon {
  color: $blue500;
}
